<template>
  <div class="page" :style="{ paddingBottom: toBottom }">
    <div class="popup">
      <img src="@/assets/ic-close.png" class="close-icon" @click="closePopup" />

      <!-- 聊天内容区 -->
      <div
        class="chat-content"
        ref="chatContentRef"
        :style="{ height: chatContentHeight + 'px' }"
      >
        <div class="message-list-wrapper">
          <div class="message-list" ref="messageListRef">
          <div
            v-for="(msg, index) in displayMessageList"
            :key="index"
            :class="['message-item', msg.type === 'user' ? 'user' : 'ai']"
          >
            <div class="message-content">
              <img
                class="user_avatar"
                v-if="msg.type === 'user'"
                src="@/assets/people-avatar.png"
              />
              <img
                class="ai_avatar"
                v-if="msg.type === 'ai'"
                src="@/assets/teacher-avatar.png"
              />
              <div class="message-wrapper">
                <div class="userBox">
                  <div class="ai-teacher" v-if="msg.type === 'ai'">Miya老师</div>
                  <div class="user-name" v-if="msg.type === 'user'">{{userInfo?.nickname}}</div>

                  <!-- 只显示图片的消息 -->
                  <img
                    v-if="msg.displayType === 'image' && msg.ext"
                    @click="previewFn(msg)"
                    class="pic_icon1"
                    :src="
                      isValidFileInfo(msg.ext)
                        ? JSON.parse(msg.ext).filePath
                        : ''
                    "
                  />

                  <!-- 只显示文本的消息 -->
                  <div
                    v-if="msg.displayType === 'text' && msg.renderedContent"
                    class="selectable-text"
                    :class="{ userText: msg.type === 'user' }"
                    v-html="msg.renderedContent"
                  ></div>

                  <!-- 时间显示 -->
                  <div
                    v-if="msg.createTime && !msg.loading"
                    class="message-time"
                    :class="{
                      'user-time': msg.type === 'user',
                      'ai-time': msg.type === 'ai',
                    }"
                  >
                    {{ formatTime(msg.createTime) }}
                  </div>
                </div>
                <div
                  v-if="msg.type === 'ai' && msg.loading"
                  class="ai-loading-container"
                >
                  <div class="loading-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
                <div
                  v-if="
                    msg.type === 'ai' &&
                    isResponding &&
                    index === displayMessageList.length - 1
                  "
                  class="stop-btn"
                  @click="stopResponse"
                >
                  停止输出
                </div>
              </div>
            </div>
          </div>
          <div class="picBox" v-if="picShow">
            <img
              class="del_pic"
              src="@/assets/ic-close.png"
              @click="delPicFn"
            />
            <img class="pic_icon" src="@/assets/ic-close.png" />
            <div class="pic_msg">
              <div v-if="picShow == 2">
                <span>{{ ext.fileName?.split(".")[0] }}</span
                ><span>.{{ ext.fileName?.split(".")[1] }}</span>
              </div>
              <div style="margin: 2px" v-if="picShow == 2">
                {{ formatFileSize(ext.fileSize) }}
              </div>
              <div v-if="picShow == 1">上传中...</div>
            </div>
          </div>
        </div>
        </div>
      </div>

      <!-- 底部输入区 -->
      <div v-if="!isShowVoice" class="input-area">
        <div v-if="showTips && tipsList.length > 0" class="tips-container">
          <div class="tab-scroll">
            <div class="tab-list">
              <div
                v-for="(item, index) in tipsList"
                :key="index"
                class="tab-item"
                @click="selectTip(item.context)"
              >
                {{ item.context }}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div v-if="!isshowSpeakIcon" class="enterBox">
            <img
              src="@/assets/ic-voice.png"
              class="ic-voice"
              @click="toggleInputMode"
            />
            <input
              type="text"
              @focus="changefocus"
              @blur="changeblur()"
              v-model="inputContent"
              placeholder="发消息..."
              maxlength="5000"
            />
            <!-- <img src="@/assets/ic-send.png" @click="sendMessage" :class="{
              actAsk: inputContent?.length == 0 && picShow == 0,
            }"/> -->
          </div>
          <img
            src="@/assets/ic-keyboard.png"
            class="ic-keyboard"
            @click="toggleInputMode"
            v-if="isshowSpeakIcon"
          />
          <div
            v-if="isshowSpeakIcon"
            @mousedown="showSpeckPop"
            class="speckBox"
          >
            <!-- <img
              src="@/assets/ic-keyboard.png"
              class="input-icon"
              @click="toggleInputMode"
            /> -->
            <div
              class="speakIcon"
              @mousedown="startPress"
              @mousemove="handleMove"
              @mouseup="cancelPress"
              @mouseleave="cancelPress"
              @touchstart.passive="startPress"
              @touchmove.passive="handleMove"
              @touchend.passive="cancelPress"
              :class="{ active: isShowVoice }"
            >
              按住说话
            </div>
          </div>

          <!-- 如果可以暂停输出，显示停止图标；否则显示发送按钮 -->
          <img
            v-if="!isshowSpeakIcon && canStopResponse"
            src="@/assets/ic-stop.png"
            class="icon"
            @click="stopResponse"
          />
          <img
            v-else-if="!isshowSpeakIcon"
            :src="
              canSend
                ? require('@/assets/ic-send1.png')
                : require('@/assets/ic-send.png')
            "
            class="icon"
            :class="{ disabled: !canSend }"
            @click="handleSendClick"
          />
        </div>
      </div>
    </div>

    <!-- 语音录音弹窗组件 -->
    <VoicePop
      :showPopUp="isShowVoice"
      :isCanceling="isCanceling"
      @close="handleVoiceClose"
      @saveVoice="saveVoice"
    />
  </div>
</template>

<script>
export default {
  name: "AskHomePage",
};
</script>

<script setup>
/* eslint-disable no-unused-vars */
import { ref, onMounted, nextTick, onUnmounted, computed } from "vue";

import {
  aiAuth,
  getPromptList,
  getQuickReplyList,
  createWordChat,
  sendWordChatCompletionsStream,
  mp3ToText,
  stopWordChatCompletions
} from "@/api/chat.js";
import katex from "katex";
import "katex/dist/katex.min.css";
import { marked } from "marked";
import VoicePop from "@/components/voice/VoicePop.vue";

const title = ref("");
const inputContent = ref("");
const isShowVoice = ref(false);
const messageList = ref([]);
const chatContentHeight = ref(0);
const showScroll = ref(false);
const isResponding = ref(false);
const currentChatId = ref("");
// 当前英语单词 completions 的流式句柄（用于停止输出）
let currentWordStream = null;
const showTips = ref(true);
const tipsList = ref([]);
const planId = ref("");
const tutoringId = ref("");
const picShow = ref(0);
const ext = ref({});
const imageUrl = ref("");
const chatContentRef = ref(null);
const messageListRef = ref(null);
const isshowSpeakIcon = ref(false);
const isCanceling = ref(false);
const toBottom = ref("0");
const token = ref("");
const deviceType = ref("");
const gradeId = ref("");
const volumnId = ref("");
const aiToken = ref("");
// 固定的 aiToken（用于开发环境和生产环境兜底）
const FALLBACK_AI_TOKEN =
  "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoiYjM2ZDQyNDU1YjQ4NDVkOGI0ZDRhY2VjMzU5NDQzYTQiLCJ1c2VyX2tleSI6ImIzNmQ0MjQ1NWI0ODQ1ZDhiNGQ0YWNlYzM1OTQ0M2E0IiwidXVpZCI6IjQ3NjVhZTFmLWRiM2UtNDZlOC04ZTFmLTFjNDUwNmM5MzZlZCIsImxldmVsX3NvcnQiOm51bGx9.onX037IGymrf71ZdtxC91g8ZF5X8TYYUs8VIB2jz3BZhOpIq12yTt4e5IZUq4-1WOGSLObZB0bZXC00ZZAHUmw";
const promptId = ref(""); // 当前选中的模板 promptId（用于创建对话）
const wordInfo = ref(null); // 安卓返回的单词信息
const userInfo = ref(null); // 安卓返回的用户信息（用于 nickname/grade）
// 录音相关（已移至 VoicePop 组件）

// 是否可以发送（有文本或有图片）
const canSend = computed(() => {
  return (
    !!inputContent.value.trim() ||
    !!imageUrl.value
  );
});

// 临时联调：先写死 wordId（后续再切回安卓回传）
const getCurrentWordId = () => {
  return "01d0f7126f844edf8d8791547fd6b4a7";
};

function fetchQuickReplyList() {
  const wordId = getCurrentWordId();
  getQuickReplyList(wordId, aiToken.value)
    .then((res) => {
      if (res.code === 200) {
        const list = res.data;
        console.log("获取快捷回复列表成功:", list);
        tipsList.value = list;
      } else {
        console.error("获取快捷回复列表失败:", res);
      }
    })
    .catch((error) => {
      console.error("获取快捷回复列表错误:", error);
    })
    .finally(() => {
      console.log("获取快捷回复列表完成");
    });
}
// 创建“英语单词对话”（需要 aiToken + wordInfo.word）
const isCreatingChat = ref(false);
async function createWordDialogueIfReady() {
  if (isCreatingChat.value) return;
  if (!aiToken.value) return;
  if (!promptId.value) return;
  const w = wordInfo.value;
  // 联调兜底：如果安卓暂时没回 word，则先用固定单词创建对话，确保接口能打通
  const wordForCreate = w && w.word ? String(w.word || "") : "happy";
  // 已有对话则不重复创建
  if (currentChatId.value) return;

  isCreatingChat.value = true;
  try {
    const payload = {
      modelType: 0,
      promptId: promptId.value,
      message: `我要学习${String(w?.name || wordForCreate)}这个单词`,
      nickname: userInfo.value?.nickname || "666",
      grade:
        userInfo.value?.grade ||
        (gradeId.value ? String(gradeId.value) : "") ||
        4,
      word: wordForCreate,
    };

    console.log("🧪 创建英语单词对话 payload:", payload);
    const res = await createWordChat(payload, aiToken.value);
    console.log("🧪 创建英语单词对话 response:", res);
    if ((res.code === 200 || res.code === 0) && res.data) {
      currentChatId.value = res.data.id || "";
      title.value = res.data.title || "";

      // 将后端 messages 映射到现有 messageList 结构
      // 注意：时间统一由前端设置，不依赖后端返回的 createTime
      const msgs = Array.isArray(res.data.messages) ? res.data.messages : [];
      messageList.value = msgs.map((m) => {
        const role = m?.role || "";
        const context = m?.context || "";
        const isUser = role === "user" || role === "USER";
        return {
          type: isUser ? "user" : "ai",
          content: context,
          renderedContent: isUser ? context : renderMath(context),
          loading: false,
          ext: "{}",
          createTime: new Date(), // 统一由前端设置时间
        };
      });

      // 创建新对话后：立刻调用“发送消息”接口（只传 3 个参数）
      let aiMessageIndex = -1; // 在 try 块外定义，确保 catch 块可以访问
      try {
        const nickname = userInfo.value?.nickname || "666";
        const firstMsg = `你好呀~ 可以教教我 "${String(w?.name || wordForCreate)}" 这个单词吗？`;

        // 先把这条“用户消息”塞进列表，UI 更直观
        messageList.value.push({
          type: "user",
          content: firstMsg,
          renderedContent: firstMsg,
          createTime: new Date(),
          ext: "{}",
        });
        aiMessageIndex = messageList.value.length;
        messageList.value.push({
          type: "ai",
          content: "",
          renderedContent: "",
          loading: true,
          createTime: new Date(),
          ext: "{}",
        });
        scrollToBottom();

        const payload3 = {
          chatRecordId: currentChatId.value,
          message: firstMsg,
          nickname,
          
        };
        console.log("🧪 创建后首条消息 payload(3):", payload3);

        isResponding.value = true;
        let accumulatedText = "";
        currentWordStream = sendWordChatCompletionsStream(
          payload3,
          (text) => {
            if (messageList.value[aiMessageIndex]?.loading) {
              messageList.value[aiMessageIndex].loading = false;
            }
            accumulatedText += text || "";
            messageList.value[aiMessageIndex].content = accumulatedText;
            messageList.value[aiMessageIndex].renderedContent =
              renderMath(accumulatedText);
            scrollToBottom();
          },
          aiToken.value
        );
        await currentWordStream;
        currentWordStream = null;
        isResponding.value = false;
        // AI 回复加载完成时，更新时间
        messageList.value[aiMessageIndex].createTime = new Date();
        if (!messageList.value[aiMessageIndex].content) {
          messageList.value[aiMessageIndex].content = "";
          messageList.value[aiMessageIndex].renderedContent = renderMath(
            messageList.value[aiMessageIndex].content
          );
          scrollToBottom();
        }
      } catch (e) {
        console.error("创建后首条消息失败:", e);
        isResponding.value = false;
        currentWordStream = null;
        // 错误时也更新时间
        if (messageList.value[aiMessageIndex]) {
          messageList.value[aiMessageIndex].createTime = new Date();
        }
      }

      scrollToBottom();
    } else {
      console.error("创建英语单词对话失败:", res);
    }
  } catch (e) {
    console.error("创建英语单词对话异常:", e);
  } finally {
    isCreatingChat.value = false;
  }
}

// 配置 marked 选项（只执行一次，提升性能）
marked.setOptions({
  // 启用 GFM，并让单个换行符也被当作 <br> 处理
  gfm: true,
  breaks: true,
  headerIds: true,
  mangle: false,
  headerPrefix: "",
  sanitize: false,
  smartLists: true,
  xhtml: true,
});

// 处理 Markdown（保留基础 Markdown 加粗/斜体/标题/换行等）
const renderMath = (text) => {
  try {
    let safeText = typeof text === "string" ? text : String(text ?? "");

    // 把字符串里的 `\n` 和真正的换行，都统一成换行符，方便 marked 处理为 <br> 或新段落
    safeText = safeText.replace(/\\n/g, "\n");

    // 避免 $$\n 被错误拆行
    safeText = safeText.replace(/\$\$\n/g, "$$");

    // 转义下划线，防止被解析为 Markdown 斜体语法
    // marked 会将单个下划线 _text_ 解析为斜体 <em>，我们需要转义这些下划线
    // 但保留双下划线 __text__（粗体）和已转义的下划线 \_
    // 匹配单个下划线（前面不是反斜杠，后面不是下划线）
    safeText = safeText.replace(/([^\\])_(?!_)/g, '$1\\_');
    // 处理行首的单个下划线
    safeText = safeText.replace(/^_(?!_)/gm, '\\_');

    const html = marked.parse(safeText);
    
    // 将删除线标签改为下划线标签
    // 将 <del> 和 <s> 标签替换为 <u> 标签，使删除线显示为下划线
    let finalHtml = html.replace(/<del>/g, '<u>').replace(/<\/del>/g, '</u>');
    finalHtml = finalHtml.replace(/<s>/g, '<u>').replace(/<\/s>/g, '</u>');
    
    return `<div class="ai-message-box markdown-body">${finalHtml}</div>`;
              } catch (e) {
    console.error("处理文本时出错:", e);
    // 兜底：出错时至少返回原始文本
    return `<div class="ai-message-box markdown-body">${text || ""}</div>`;
  }
};

// 停止响应
const stopResponse = async () => {
  try {
    // 立即关闭 loading 状态（找到最后一条 AI 消息并关闭其 loading）
    for (let i = messageList.value.length - 1; i >= 0; i--) {
      if (messageList.value[i].type === 'ai' && messageList.value[i].loading) {
        messageList.value[i].loading = false;
        break;
      }
    }
    
    // 调用停止输出接口
    if (currentChatId.value) {
      try {
        await stopWordChatCompletions(
          currentChatId.value, // chatRecordId 作为路径参数
          aiToken.value // token 作为第二个参数，会自动设置到 X-Authorization-Token header
        );
        console.log("停止输出接口调用成功");
      } catch (error) {
        console.error("停止输出接口调用失败:", error);
        // 即使接口调用失败，也要继续执行后续的本地停止逻辑
      }
    }
    
    // 停止流式请求
    if (currentWordStream && typeof currentWordStream.abort === "function") {
      currentWordStream.abort();
      currentWordStream = null;
    }
    
    // 更新状态
    isResponding.value = false;
    console.log("已停止输出");
  } catch (error) {
    console.error("停止输出失败:", error);
    // 确保状态被重置
    isResponding.value = false;
    currentWordStream = null;
    
    // 确保 loading 状态被关闭
    if (displayMessageList.value.length > 0) {
      const lastMessage = displayMessageList.value[displayMessageList.value.length - 1];
      if (lastMessage && lastMessage.type === 'ai') {
        for (let i = messageList.value.length - 1; i >= 0; i--) {
          if (messageList.value[i].type === 'ai') {
            messageList.value[i].loading = false;
            break;
          }
        }
      }
    }
  }
};

const sendMessage = () => {
  if (!canSend.value) return;
  if (isResponding.value) {
    console.log("AI正在输出，其他操作请停止输出");
    return;
  }
  if (inputContent.value?.length == 0 && imageUrl.value?.length == 0) {
    return;
  }
  if (
    (!inputContent.value.trim() && imageUrl.value?.length == 0) ||
    isResponding.value
  )
    return;

  isResponding.value = true;
  const userMessage = inputContent.value;

  // 深拷贝当前图片URL
  const currentImageUrl = imageUrl.value
    ? JSON.parse(JSON.stringify(imageUrl.value))
    : "";

  // 添加用户消息，包含图片信息
  messageList.value.push({
    type: "user",
    content: userMessage,
    renderedContent: userMessage,
    createTime: new Date(),
    ext: JSON.stringify(
      JSON.parse(
        JSON.stringify({
          ...ext.value,
        })
      )
    ),
  });
  if (messageList.value.length == 2) {
    title.value =
      messageList.value[1].content && !isValidFileInfo(messageList.value[1].ext)
        ? messageList.value[1].content
        : "图片答疑";
  }
  // 添加一个带加载状态的AI消息
  const aiMessageIndex = messageList.value.length;
  messageList.value.push({
    type: "ai",
    content: "",
    renderedContent: "",
    loading: true,
    createTime: new Date(),
  });

  // 清空输入和图片
  inputContent.value = "";
  picShow.value = 0;
  let accumulatedText = "";

  scrollToBottom();

  let params = {
    chatRecordId: currentChatId.value,
    imageUrl: currentImageUrl ? currentImageUrl : "",
    ext: JSON.stringify(
      JSON.parse(
        JSON.stringify({
          ...ext.value,
        })
      )
    ),
    message: userMessage,
  };
  picShow.value = 0;

  // 真实联调：英语单词-发送消息（流式）
  (async () => {
    try {
      // 清理图片相关状态（避免下一次发送残留）
      ext.value = {};
      imageUrl.value = "";

      // 只传 3 个参数：chatRecordId / message / nickname
      const payload = {
        chatRecordId: params.chatRecordId,
        message: params.message,
        nickname: userInfo.value?.nickname || "666",
      };

      console.log("🧪 发送英语单词消息 payload:", payload);
      accumulatedText = "";
      isResponding.value = true;

      currentWordStream = sendWordChatCompletionsStream(
        payload,
        (text) => {
          if (messageList.value[aiMessageIndex]?.loading) {
      messageList.value[aiMessageIndex].loading = false;
    }
          accumulatedText += text || "";
          messageList.value[aiMessageIndex].content = accumulatedText;
          messageList.value[aiMessageIndex].renderedContent =
            renderMath(accumulatedText);
          scrollToBottom();
        },
        aiToken.value
      );

      await currentWordStream;
      currentWordStream = null;
    isResponding.value = false;
      // AI 回复加载完成时，更新时间
      messageList.value[aiMessageIndex].createTime = new Date();

      if (!messageList.value[aiMessageIndex].content) {
        messageList.value[aiMessageIndex].loading = false;
        messageList.value[aiMessageIndex].content = "";
    messageList.value[aiMessageIndex].renderedContent = renderMath(
      messageList.value[aiMessageIndex].content
    );
    }
    scrollToBottom();
    } catch (error) {
      console.error("发送英语单词消息失败:", error);
      if (messageList.value[aiMessageIndex]?.loading) {
        messageList.value[aiMessageIndex].loading = false;
      }
      isResponding.value = false;
      currentWordStream = null;
      // 错误时也更新时间
      messageList.value[aiMessageIndex].createTime = new Date();
      messageList.value[aiMessageIndex].content =
        "请求失败，请稍后再试（或检查网络/跨域/aiToken）。";
      messageList.value[aiMessageIndex].renderedContent = renderMath(
        messageList.value[aiMessageIndex].content
      );
      scrollToBottom();
    }
  })();
};

const scrollToBottom = () => {
  nextTick(() => {
    if (messageListRef.value && chatContentRef.value) {
      const messageListHeight = messageListRef.value.scrollHeight;
      const chatContentHeight = chatContentRef.value.clientHeight;
      showScroll.value = messageListHeight > chatContentHeight;
      if (showScroll.value) {
        chatContentRef.value.scrollTop = messageListHeight;
      }
    }
  });
};

// const loadMore = () => {
//   // 加载更多历史消息
// };

const selectTip = (tip) => {
  inputContent.value = tip;
};

// 防抖函数
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// 计算聊天区域高度（使用防抖优化性能）
const calculateChatContentHeight = debounce(() => {
  const windowHeight = window.innerHeight;
  const header = document.querySelector(".header");
  const inputArea = document.querySelector(".input-area");

  if (header && inputArea) {
    const headerHeight = header.offsetHeight;
    const inputAreaHeight = inputArea.offsetHeight;
    chatContentHeight.value = windowHeight - headerHeight - inputAreaHeight;
  } else {
    // 如果没有header，使用popup的高度
    chatContentHeight.value =
      windowHeight - (inputArea?.offsetHeight || 0) - 100;
  }
}, 150);

function delPicFn() {
  imageUrl.value = "";
  ext.value = {};
  picShow.value = 0;
}

function previewFn(arg) {
  let url = arg.imageUrl ? arg.imageUrl : JSON.parse(arg.ext).filePath;
  // TODO: 实现图片预览功能
  window.open(url);
}

function newDialogue(promptId, arg) {
  if (arg) {
    tutoringId.value = arg;
    planId.value = arg;
  }
  messageList.value = [];
  // let params = {
  //   modelType: 0,
  //   promptId,
  //   message: "",
  // };
  // newChat({
  //   ...params,
  // }).then((res) => {
  //   currentChatId.value = res.data.id;
  //   if (res.code == 200) {
  //     messageList.value.push({
  //       type: "ai",
  //       content: "",
  //       renderedContent: `<view class="ai-message-box"><div class="toast-text-line">${renderMath(
  //         res.data.messages[0].role
  //       )}<div><span class="time">${
  //         res.data.messages[0].createTime
  //       }</span>	</view>`,
  //     });
  //     getTip(res.data.id);
  //     title.value = res.data.title;
  //   }
  // });
}

// 加载模拟消息数据（延迟执行，提升性能）
function loadMockMessages() {
  // 第一条用户消息
  const time1 = new Date();
  messageList.value.push({
    type: "user",
    content: "你好，我想学习英语，能给我一些建议吗？",
    renderedContent: "你好，我想学习英语，能给我一些建议吗？",
    ext: "{}",
    createTime: time1,
  });

  // 第一条AI回复
  setTimeout(() => {
    const time2 = new Date();
    const aiContent1 =
      "你好！很高兴帮助你学习英语。以下是一些学习建议：\n\n1. **每天坚持练习**：每天至少花30分钟练习英语\n2. **多听多说**：通过听英语音频和与他人对话来提高\n3. **阅读英文材料**：阅读英文文章、书籍来扩大词汇量\n4. **使用学习应用**：利用各种英语学习应用来辅助学习\n\n你想从哪个方面开始呢？";
    messageList.value.push({
      type: "ai",
      content: aiContent1,
      renderedContent: renderMath(aiContent1),
      loading: false,
      createTime: time2,
    });
    scrollToBottom();
  }, 500);

  // 第二条用户消息
  setTimeout(() => {
    const time3 = new Date();
    messageList.value.push({
      type: "user",
      content: "我想提高我的词汇量，有什么好的方法吗？",
      renderedContent: "我想提高我的词汇量，有什么好的方法吗？",
      ext: "{}",
      createTime: time3,
    });

    // 第二条AI回复
    setTimeout(() => {
      const time4 = new Date();
      const aiContent2 =
        "提高词汇量有很多有效的方法：\n\n**1. 使用单词卡片**\n制作单词卡片，一面写英文，一面写中文，定期复习。\n\n**2. 阅读英文文章**\n在阅读中遇到生词时，先尝试根据上下文猜测意思，然后再查字典。\n\n**3. 使用记忆技巧**\n- 联想记忆：将新单词与已知单词或图像联系起来\n- 词根词缀：学习常见的词根和词缀\n- 分类记忆：按主题分类记忆单词\n\n**4. 实际应用**\n尝试用新学的单词造句，在实际对话中使用它们。\n\n**5. 使用APP**\n推荐使用 Anki、Quizlet 等应用来系统化学习。\n\n建议每天学习10-20个新单词，并复习之前学过的单词。";
      messageList.value.push({
        type: "ai",
        content: aiContent2,
        renderedContent: renderMath(aiContent2),
        loading: false,
        createTime: time4,
      });
      scrollToBottom();
    }, 800);
  }, 2000);
}

// 获取模板列表（使用 aiAuth 获取到的 aiToken）
function fetchPromptList() {
  // 使用 aiAuth 获取到的 aiToken，而不是安卓给的 token
  if (!aiToken.value) {
    console.warn("⚠️ aiToken 未获取，无法调用模板列表接口");
    return;
  }
  
  getPromptList(aiToken.value)
    .then((res) => {
      if ((res.code === 200 || res.code === 0) && res.data) {
        promptId.value = res.data.promptId;
        createWordDialogueIfReady();
      } else {
        console.error("获取模板列表失败:", res);
      }
    })
    .catch((error) => {
      // 检测跨域错误
      if (
        error instanceof TypeError &&
        (error.message.includes("Failed to fetch") ||
          error.message.includes("NetworkError") ||
          error.message.includes("Network request failed"))
      ) {
        console.error("❌ 获取模板列表接口跨域错误:", error);
      } else {
        console.error("获取模板列表错误:", error);
      }
    });
}

// 链式初始化：getToken -> aiAuth -> getPromptList -> createWordChat
function bootstrapWordChatChain() {
  // 只要 currentChatId 已有，就不再重复跑链
  if (currentChatId.value) return;
  if (!aiToken.value) return;
  fetchPromptList();
}

// function getGradeFn() {
//   getGrade().then((res) => {
//     if (res.code == 200) {
//       gradeList.value = res.data;
//     }
//   });
// }

const isValidFileInfo = (ext) => {
  try {
    const fileInfo = JSON.parse(ext);
    return fileInfo && fileInfo.fileName;
  } catch {
    return false;
  }
};

// 格式化文件大小
function formatFileSize(bytes) {
  const kb = 1024;
  const mb = 1024 * 1024;

  if (bytes < kb) {
    return bytes + " Bytes";
  } else if (bytes < mb) {
    return (bytes / kb).toFixed(2) + " KB";
  } else {
    return (bytes / mb).toFixed(2) + " MB";
  }
}

// 格式化时间
function formatTime(time) {
  if (!time) return "";

  let date;
  if (typeof time === "string") {
    date = new Date(time);
  } else if (typeof time === "number") {
    date = new Date(time);
  } else {
    date = time;
  }

  if (isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
}

const displayMessageList = computed(() => {
  return messageList.value.reduce((acc, msg) => {
    if (msg.type === "user" && isValidFileInfo(msg.ext) && msg.content) {
      // 如果是用户消息且同时包含图片和文本，拆分为两条
      acc.push({
        ...msg,
        displayType: "image",
      });
      acc.push({
        ...msg,
        displayType: "text",
        ext: "{}", // 清空文本消息的ext，避免重复显示图片
      });
    } else {
      // 其他情况（AI消息或只有图片/文本的用户消息）
      acc.push({
        ...msg,
        displayType:
          msg.type === "user" && isValidFileInfo(msg.ext) ? "image" : "text",
      });
    }
    return acc;
  }, []);
});

// 计算是否可以暂停输出（当前正在响应且最后一条消息是 AI 消息）
const canStopResponse = computed(() => {
  return (
    isResponding.value &&
    displayMessageList.value.length > 0 &&
    displayMessageList.value[displayMessageList.value.length - 1]?.type === 'ai'
  );
});

const showVoicePopup = () => {
  isshowSpeakIcon.value = !isshowSpeakIcon.value;
  if (isshowSpeakIcon.value) {
    inputContent.value = "";
    isShowVoice.value = false;
  }
};

// 切换输入模式（键盘/语音）
const toggleInputMode = () => {
  isshowSpeakIcon.value = !isshowSpeakIcon.value;
  if (isshowSpeakIcon.value) {
    inputContent.value = "";
    isShowVoice.value = false;
  }
};

const saveVoice = (val) => {
  if (!isCanceling.value) {
    mp3ToText(
      {
      base64: val,
      },
      aiToken.value // 传入 aiToken
    )
      .then((res) => {
        if (res.code === 200 && res.data) {
          inputContent.value = res.data;
        } else {
          console.error("语音转文本失败:", res);
        }
      })
      .catch((error) => {
        // 检测跨域错误
        if (
          error instanceof TypeError &&
          (error.message.includes("Failed to fetch") ||
            error.message.includes("NetworkError") ||
            error.message.includes("Network request failed"))
        ) {
          console.error("❌ 语音转文本接口跨域错误:", error);
        } else {
          console.error("语音转文本错误:", error);
        }
      });
  }
  // 只有在成功保存语音后才切换回输入模式
  isshowSpeakIcon.value = false;
  isShowVoice.value = false;
};

const showSpeckPop = () => {
  // 语音弹窗显示逻辑
};

const isLongPress = ref(false);
const startY = ref(0);
const moveY = ref(0);
let timer = null;

const startPress = (event) => {
  event?.stopPropagation();
  startY.value = event.type.includes("touch")
    ? event.touches[0].clientY
    : event.clientY;
  moveY.value = startY.value;
  isCanceling.value = false;

  timer = setTimeout(() => {
    isLongPress.value = true;
    isShowVoice.value = true;
    // 语音弹窗组件会自动开始录音
  }, 200);
};

const handleMove = (event) => {
  if (!isLongPress.value) return;
  const currentY = event.type.includes("touch")
    ? event.touches[0].clientY
    : event.clientY;
  moveY.value = currentY;
  const distance = startY.value - currentY;
  if (distance > 150) {
    isCanceling.value = true;
  } else {
    isCanceling.value = false;
  }
};

const cancelPress = (event) => {
  event?.stopPropagation();
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  
  // 如果还没有开始长按，直接返回
  if (!isLongPress.value && !isShowVoice.value) {
    return;
  }

  isLongPress.value = false;

  // 保存取消状态（在关闭弹窗前保存，确保组件能读取到）
  const shouldCancel = isCanceling.value;

  // 关闭弹窗，组件会根据 isCanceling 状态决定是否保存录音
  isShowVoice.value = false;

  // 重置状态
  startY.value = 0;
  moveY.value = 0;
  // 延迟重置 isCanceling，确保组件能正确读取到状态
  setTimeout(() => {
    isCanceling.value = false;
  }, 200);
};

const changefocus = function () {
  toBottom.value = "340px";
  const showBoard = JSON.stringify({
    func: "getCanShowKeyBoard",
    params: {
      canShow: true
    }
  });
  if (window.android) {
    window.android.callNative(showBoard);
  }
};

const changeblur = function () {
  toBottom.value = "0";
  scrollToBottom();
};

// 发送按钮点击（包装一层，避免在模板里写过多逻辑）
const handleSendClick = () => {
  if (!canSend.value) return;
  sendMessage();
};

// 关闭弹窗逻辑（参考 walkman 返回退出逻辑）
function closePopup() {
  const quitRequest = JSON.stringify({
    func: "getDialogDismiss",
  });
  if (window.android) {
    window.android.callNative(quitRequest);
  }
}

// callJS 函数：处理原生调用
function callJS(data) {
  console.log(data,999)
  const res = JSON.parse(data);
  console.log("res", res);
  if (res.func == "getToken") {
    // 保存 token 到本地存储
    localStorage.setItem("token", res.params.accessToken);
    token.value = res.params.accessToken;
    gradeId.value = res.params.gradeId || 1;
    volumnId.value = res.params.volumeId || 1;
    planId.value = res.params.planId;
    tutoringId.value = res.params.tutoringId;
    deviceType.value = res.params.device;
    localStorage.setItem("deviceType", deviceType.value);
    
    // 获取 host（可能是 host、baseUrl、domain 等字段）
    const host = res.params.host || res.params.baseUrl || res.params.domain || res.params.hostname || '';
    if (host) {
      // 构建完整的 baseUrl
      const protocol = host.startsWith('http') ? '' : (window.location.protocol === 'https:' ? 'https://' : 'http://');
      const dynamicBaseUrl = `${protocol}${host}/fzd-ceplatform-englishapp`;
      const dynamicRagBaseUrl = `${protocol}${host}/fzd-ceplatform-rag`;
      
      // 保存到 localStorage，供 request.js 使用
      localStorage.setItem('dynamicBaseUrl', dynamicBaseUrl);
      localStorage.setItem('dynamicRagBaseUrl', dynamicRagBaseUrl);
      localStorage.setItem('dynamicHost', host);
      
      console.log('✅ [chat] 从安卓获取到 host:', host);
      console.log('✅ [chat] 设置动态 baseUrl:', dynamicBaseUrl);
      console.log('✅ [chat] 设置动态 ragBaseUrl:', dynamicRagBaseUrl);
    }
    
    // 调用AI服务认证接口
    aiAuth()
      .then((authRes) => {
        if (authRes.code === 200 && authRes.data) {
          aiToken.value = authRes.data;
          console.log("aiToken", aiToken.value);
          fetchQuickReplyList();
          // 链式：拿到 aiToken 后继续拉模板并创建对话
          bootstrapWordChatChain();
        } else {
          // 如果接口返回失败或没有 data，使用固定的 token 作为兜底
          console.warn(
            "⚠️ AI服务认证返回失败或无数据，使用固定 token 作为兜底"
          );
          aiToken.value = FALLBACK_AI_TOKEN;
          fetchQuickReplyList();
          bootstrapWordChatChain();
        }
        newDialogue(planId.value ? planId.value : tutoringId.value);
      })
      .catch((error) => {
        // 检测跨域错误
        if (
          error instanceof TypeError &&
          (error.message.includes("Failed to fetch") ||
            error.message.includes("NetworkError") ||
            error.message.includes("Network request failed"))
        ) {
          console.error("❌ AI服务认证接口跨域错误:", error);
        } else {
          console.error("AI服务认证失败:", error);
        }
        // 认证失败时，使用固定的 token 作为兜底
        console.warn("⚠️ AI服务认证失败，使用固定 token 作为兜底");
        aiToken.value = FALLBACK_AI_TOKEN;
        fetchQuickReplyList();
        bootstrapWordChatChain();
      });
  }
  if (res.func == "getShowKeyBoard") {
    if (!res.params.canShow) {
      changeblur();
    } else {
      changefocus();
    }
  }

  if (res.func == "getTakePhotoInfo") {
    imageUrl.value = res.params[0].filePath;
    ext.value = res.params[0];
    picShow.value = 2;

    // 方案2：监听图片加载完成后滚动
    const img = new Image();
    img.onload = () => {
      nextTick(() => {
        scrollToBottom();
      });
    };
    img.src = res.params[0].filePath;
  }

  if (res.func == "getUserInfo") {
    userInfo.value = res.params || null;
  }

  // 获取安卓传过来的单词信息
  if (res.func == "getWordInfo") {
    console.log("安卓返回 getWordInfo 数据:", res.params);
    wordInfo.value = res.params || null;
    
  }
}

// 请求 token
function goToken() {
  const tokenRequest = JSON.stringify({
    func: "getToken",
  });
  const msg = JSON.stringify({
    func: "getUserInfo",
  });
  const closeLoading = JSON.stringify({
    func: "canPlayGame",
  });
  const wordInfoRequest = JSON.stringify({
    func: "getWordInfo",
  });
  if (window.android) {
    window.android.callNative(tokenRequest);
    window.android.callNative(msg);
    window.android.callNative(closeLoading);
    // 进入页面时主动向安卓请求单词信息
    window.android.callNative(wordInfoRequest);
  }
}

// 本地/无安卓环境：直接使用写死的 aiToken（不用调用 aiAuth）
function initWithDevAiToken() {
  // 这里使用你提供的 token 作为 aiToken
  aiToken.value =
    "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoiYjM2ZDQyNDU1YjQ4NDVkOGI0ZDRhY2VjMzU5NDQzYTQiLCJ1c2VyX2tleSI6ImIzNmQ0MjQ1NWI0ODQ1ZDhiNGQ0YWNlYzM1OTQ0M2E0IiwidXVpZCI6IjQ3NjVhZTFmLWRiM2UtNDZlOC04ZTFmLTFjNDUwNmM5MzZlZCIsImxldmVsX3NvcnQiOm51bGx9.onX037IGymrf71ZdtxC91g8ZF5X8TYYUs8VIB2jz3BZhOpIq12yTt4e5IZUq4-1WOGSLObZB0bZXC00ZZAHUmw";

  // 可选：同步一份到 localStorage，方便其它地方调试复用
  localStorage.setItem("aiToken", aiToken.value);

  // 直接走后续链路：获取模板 -> 创建对话
  bootstrapWordChatChain();
}

// 检测浏览器类型
function detectBrowser() {
  const userAgent = navigator.userAgent;
  let browserName = "Unknown";
  let browserVersion = "";

  if (
    userAgent.indexOf("Chrome") > -1 &&
    userAgent.indexOf("Edg") === -1 &&
    userAgent.indexOf("OPR") === -1
  ) {
    browserName = "Chrome";
    const match = userAgent.match(/Chrome\/(\d+)/);
    browserVersion = match ? match[1] : "";
  } else if (userAgent.indexOf("Firefox") > -1) {
    browserName = "Firefox";
    const match = userAgent.match(/Firefox\/(\d+)/);
    browserVersion = match ? match[1] : "";
  } else if (
    userAgent.indexOf("Safari") > -1 &&
    userAgent.indexOf("Chrome") === -1
  ) {
    browserName = "Safari";
    const match = userAgent.match(/Version\/(\d+)/);
    browserVersion = match ? match[1] : "";
  } else if (userAgent.indexOf("Edg") > -1) {
    browserName = "Edge";
    const match = userAgent.match(/Edg\/(\d+)/);
    browserVersion = match ? match[1] : "";
  } else if (userAgent.indexOf("OPR") > -1) {
    browserName = "Opera";
    const match = userAgent.match(/OPR\/(\d+)/);
    browserVersion = match ? match[1] : "";
  } else if (
    userAgent.indexOf("MSIE") > -1 ||
    userAgent.indexOf("Trident") > -1
  ) {
    browserName = "IE";
    const match = userAgent.match(/(?:MSIE |rv:)(\d+)/);
    browserVersion = match ? match[1] : "";
  }

  return {
    name: browserName,
    version: browserVersion,
    userAgent: userAgent,
    platform: navigator.platform,
    language: navigator.language,
  };
}

// 录音相关逻辑已移至 VoicePop 组件

// 处理语音弹窗关闭（参照 deepseek 的逻辑）
const handleVoiceClose = () => {
  isShowVoice.value = false;
  isshowSpeakIcon.value = false;
  isCanceling.value = false;
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  isLongPress.value = false;
};

onMounted(() => {
  // 设置 callJS 函数供原生调用
  window.callJS = callJS;

  // 有安卓环境：正常走安卓链路；无安卓环境：直接使用写死的 aiToken
  if (window.android) {
  // 请求 token（token 获取后会通过 callJS 调用 newDialogue 和 fetchPromptList）
  goToken();
  } else {
    initWithDevAiToken();
  }

  // 监听窗口大小变化（已使用防抖优化）
  window.addEventListener("resize", calculateChatContentHeight);

  // 计算高度（延迟执行，避免阻塞渲染）
  if (window.requestIdleCallback) {
    requestIdleCallback(
      () => {
      calculateChatContentHeight();
      },
      { timeout: 200 }
    );
  } else {
    setTimeout(() => {
      calculateChatContentHeight();
    }, 100);
  }
});

onUnmounted(() => {
  window.removeEventListener("resize", calculateChatContentHeight);
});
</script>

<style scoped lang="scss">
.page {
  position: absolute; // 改为 absolute，相对于 #app 定位
  top: 0;
  left: 0;
  width: 960px; // 继承父容器 #app 的 960px
  height: 100%; // 继承父容器 #app 的 600px
  background: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;

  * {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
  }

  .popup {
    position: absolute;
    // 使用 top 定位，确保在不同分辨率下位置一致
    // 设计稿 600px 高度，popup 500px，所以 top = 600 - 500 = 100px
    top: 100px;
    left: 0;
    width: 960px;
    height: 500px;
    background: url("@/assets/popup-bg.png") no-repeat center center;
    background-size: cover;
    display: flex;
    flex-direction: column;

    .close-icon {
      position: absolute;
      top: -10px;
      right: 30px;
      transform: translateY(-100%);
      cursor: pointer;
      z-index: 1000;
      width: 32px;
      height: 32px;
    }

    .chat-content {
      flex: 1;
      overflow-y: auto;
      padding:0 30px;
      box-sizing: border-box;

      .message-list-wrapper {
        margin-top: 30px;
        overflow-y: scroll;
        height: calc(100% - 30px);
      }

      .message-list {
        padding: 0 0 10px;
        box-sizing: border-box;

        .message-item {
          margin-bottom: 20px;
          display: flex;

          &:last-child {
            margin-bottom: 0;
          }

          .message-content {
            display: flex;
            align-items: flex-start;
            /* gap: 15px; */
            width: 100%;
            word-break: break-all;

            .user_avatar,
            .ai_avatar {
              flex-shrink: 0;
              width: 45px;
              height: 45px;
              border-radius: 50%;
            }

            .message-wrapper {
              display: flex;
              flex-direction: column;
              max-width: 765px;

              .userBox {
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 12px;

                .ai-teacher {
                  font-weight: bold;
                  font-size: 15px;
                  color: #414650;
                  margin-bottom: 10px;
                }
                .user-name {
                  font-weight: bold;
                  font-size: 15px;
                  color: #414650;
                  margin-bottom: 10px;
                  text-align: right;
                }
                .pic_icon1 {
                  width: 100px;
                  height: 100px;
                  cursor: pointer;
                  user-select: none;
                  -webkit-user-select: none;
                }

                .selectable-text {
                  user-select: text;
                  -webkit-user-select: text;
                  border-radius: 10px;
                  word-break: break-word;
                  font-size: 14px;
                  line-height: 1.6;

                  // 保证气泡内所有标签字号统一为 14px
                  * {
                    font-size: inherit;
                  }

                  &.userText {
                    background: linear-gradient(
                      89deg,
                      #9891ff 0%,
                      #71a8ff 100%
                    );
                    color: #fff;
                    border-radius: 18px 0px 18px 18px;
                    padding: 12px;
                  }
                }

                .message-time {
                  font-size: 11px;
                  color: #8794a0;
                  margin-top: 8px;
                  white-space: nowrap;

                  &.user-time {
                    position: relative;
                    left: 0;
                    text-align: left;
                  }

                  &.ai-time {
                    position: relative;
                    left: 0px;
                    text-align: right;
                  }
                }
              }

              .ai-loading-container {

                .loading-dots {
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  padding: 12px;
                  background: #ffffff;
                  border-radius: 0 18px 18px 18px;

                  .dot {
                    border-radius: 50%;
                    animation: bounce 1.4s infinite ease-in-out;

                    &:nth-child(1) {
                      width: 10px;
                      height: 10px;
                      background: #A07DFF;
                      animation-delay: -0.32s;
                    }

                    &:nth-child(2) {
                      width: 14px;
                      height: 14px;
                      background: #A07DFF;
                      opacity: 0.8;
                      animation-delay: -0.16s;
                    }

                    &:nth-child(3) {
                      width: 16px;
                      height: 16px;
                      background: #A07DFF;
                      opacity: 0.6;
                    }
                  }
                }
              }

              .stop-btn {
                margin-top: 12px;
                border-radius: 25px;
                background: white;
                color: #6887f5;
                height: 25px;
                width: 76px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 13px;
                cursor: pointer;
              }
            }
          }

          &.user {
            flex-direction: row-reverse;

            .message-content {
              flex-direction: row-reverse;
            }

            .message-wrapper .userBox .message-time {
              text-align: right;
            }
          }

          &.ai {
            flex-direction: row;
          }
        }

        .picBox {
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-self: flex-end;
          align-items: center;
          justify-content: space-between;
          width: 245px;
          height: 59px;
          background: #ffffff;
          border-radius: 12px;
          padding: 0 10px;
          box-sizing: border-box;
          margin-bottom: 20px;

          .del_pic {
            position: absolute;
            right: 0;
            top: 0;
            transform: translate(20%, -20%);
            width: 16px;
            height: 16px;
            cursor: pointer;
          }

          .pic_icon {
            width: 32px;
            height: 29px;
          }

          .pic_msg {
            display: flex;
            flex-direction: column;
            width: 170px;
            margin-right: 10px;
            font-size: 12px;

            div {
              &:nth-child(2) {
                font-size: 10px;
                color: #666c7e;
              }
            }
          }
        }
      }
    }

    .input-area {
      position: relative;
      display: flex;
      flex-direction: column;
      min-height: 140px;
      flex-shrink: 0;
      background: #fff;
      align-items: center;
      padding: 15px 30px;
      box-sizing: border-box;
      background: url("@/assets/bottom-bg.png") no-repeat;
      background-size: 100% 100%;
      width: 100%;

      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
      }

      .tips-container {
        width: 100%;
        margin-bottom: 10px;

        .tab-scroll {
          width: 100%;
          overflow-x: auto;
          white-space: nowrap;
        }

        .tab-list {
          display: inline-flex;
          padding: 0 20px 0 0;
        }

        .tab-item {
          padding: 6px 12px;
          background: #ffffff;
          border-radius: 30px 30px 30px 30px;
          margin-right: 15px;
          font-size: 13px;
          color: #666c7e;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .voice-btn {
        margin-right: 7px;

        .voice-icon {
          width: 58px;
          height: 58px;
        }
      }

      .enterBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 25px;
        background-color: #ffffff;
        overflow: hidden;
        box-sizing: border-box;
        flex: 1;
        height: 50px;
        padding: 15px 20px;
        gap: 10px;

        input {
          flex: 1;
          height: 38px;
          background: #fff;
          padding: 0;
          font-size: 14px;
          box-sizing: border-box;
          border: none;
          outline: none;
        }

        div {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 24px;
          background: linear-gradient(270deg, #8880ff 0%, #6180ff 100%);
          box-shadow: inset 0px 2px 5px 1px rgba(255, 255, 255, 0.3);
          border-radius: 5px;
          box-sizing: border-box;
          font-size: 14px;
          color: #fff;
          cursor: pointer;

          &.actAsk {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }

      .speckBox {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        flex: 1;
        height: 50px;
        border-radius: 25px;
        background-color: #ffffff;
        overflow: hidden;
        padding: 16px 20px;
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;
        width: 835px;

        .speakIcon {
          flex: 1;
          color: #414650;
          font-weight: bold;
          padding: 10px 20px;
          text-align: center;

          &.active {
            background-color: #e0e0e0;
          }
        }
      }

      .icon {
        width: 50px;
        height: 50px;
        cursor: pointer;
        margin-left: 15px;
        &.disabled {
          opacity: 0.4;
          cursor: default;
        }
      }
      }
    }
  }
.page a {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
}
.ic-voice {
  width: 13px;
  height: 18px;
}
.ic-keyboard {
  width: 50px;
  height: 50px;
  margin-right: 15px;
}
@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

:deep(.ai-message-box) {
  width: 100%;
  word-break: break-word;
  position: relative;
  background: #ffffff;
  padding: 12px;
  border-radius: 0 18px 18px 18px;
  display: block;

  .text-line {
    color: #333;
    font-size: 14px;
    line-height: 1.6;
    background: transparent;
    padding: 0;
    margin: 0;
    overflow: hidden;
    user-select: text;
    -webkit-user-select: text;
    display: block;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  .katex {
    font-size: 1.1em;
  }

  .katex-display {
    margin: 1em 0;
    text-align: center;
  }

  // 确保下划线标签正确显示为下划线，而不是删除线
  u {
    text-decoration: underline !important;
  }

  // 确保删除线标签正确显示为删除线
  del, s {
    text-decoration: line-through !important;
  }
}

:deep(.markdown-body) {
  color: #24292e;
  line-height: 1.6;

  code {
    padding: 0.2em 0.4em;
    background-color: rgba(27, 31, 35, 0.05);
    border-radius: 3px;
  }

  pre {
    padding: 16px;
    background-color: #f6f8fa;
    border-radius: 6px;
  }

  // 确保下划线标签正确显示为下划线，而不是删除线
  u {
    text-decoration: underline !important;
  }

  // 确保删除线标签正确显示为删除线
  del, s {
    text-decoration: line-through !important;
  }
}

// 语音录音弹窗样式已移至 VoicePop 组件
</style>
